// Header
import throttle from "lodash/throttle";

const SELECTORS = {
  header: ".js-header",
};

const CLASSES = {
  navOpen: "nav-open",
  scrollDown: "is-scroll-down",
};

class SiteHeader {
  constructor(el) {
    this.header = el;
    this.lastScroll = window.pageYOffset;
    this.onScroll = throttle(this.checkScrollDirection, 200);
  }

  init() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.checkScrollDirection();
  }

  checkScrollDirection = () => {
    const y = window.pageYOffset;
    const headerHeight = this.header.offsetHeight;
    const isNavOpen = document.body.classList.contains(CLASSES.navOpen);

    if (isNavOpen || y <= headerHeight || y <= this.lastScroll) {
      document.body.classList.remove(CLASSES.scrollDown);
    } else {
      document.body.classList.add(CLASSES.scrollDown);
    }

    this.lastScroll = y;
  };
}

const headerElement = document.querySelector(SELECTORS.header);
if (headerElement) {
  const header = new SiteHeader(headerElement);
  header.init();
}
